import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { AMENITY_INCLUSION_RULES } from '@pcln/fly-ui-components'
import AncillaryElement from './AncillaryElement'

const StyledList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-top: 0;
  margin-bottom: 0;
`

function getAvailableAncillaries(brandAttributes, listOfAncillaries) {
  const AncillaryElements = []

  if (brandAttributes && brandAttributes.length > 0) {
    if (listOfAncillaries.length === 0) {
      // If ancillaries not specified, display all
      brandAttributes.forEach((brandAttribute) => {
        listOfAncillaries.push(brandAttribute.type)
      })
    }
    listOfAncillaries.forEach((coreAncillaryName) => {
      const brandAttribute = brandAttributes.find((attribute) => attribute.type === coreAncillaryName)

      if (brandAttribute) {
        const ancillaryProps = {
          type: coreAncillaryName,
          size: 16,
          fontColor: 'text.base',
        }

        ancillaryProps.description = brandAttribute.description

        switch (brandAttribute.inclusion) {
          case AMENITY_INCLUSION_RULES.INCLUDED.name:
            ancillaryProps.name = 'Check'
            ancillaryProps.iconColor = 'secondary.base'
            ancillaryProps.inclusivityText = 'Included'
            break
          case AMENITY_INCLUSION_RULES.CHARGEABLE.name:
            ancillaryProps.name = 'Dollar'
            ancillaryProps.iconColor = 'text.base'
            ancillaryProps.inclusivityText = 'For Purchase'
            break
          default:
            ancillaryProps.name = 'Close'
            ancillaryProps.iconColor = 'text.light' // Same as in details
            ancillaryProps.fontColor = 'text.light'
            ancillaryProps.inclusivityText = 'Not Included'
        }
        AncillaryElements.push(<AncillaryElement {...ancillaryProps} />)
      }
    })
  }
  return AncillaryElements
}

export default class AncillaryList extends React.Component {
  render() {
    const { brandAttributes, listOfAncillaries } = this.props
    const availableAncillaries = getAvailableAncillaries(brandAttributes, listOfAncillaries)
    return <StyledList data-autobot-element='ancillary-list'>{availableAncillaries}</StyledList>
  }
}

AncillaryList.propTypes = {
  brandAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string,
      inclusivity: PropTypes.string,
    })
  ),
  listOfAncillaries: PropTypes.arrayOf(PropTypes.string),
}

AncillaryList.defaultProps = {
  brandAttributes: [],
  listOfAncillaries: [],
}
